"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionToRSAA = exports.createInvariant = exports.ellipsis = void 0;

var _util = require("lodash/util");

var _lang = require("lodash/lang");

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var STRING_MAX_LENGTH = 30;

var ellipsis = function ellipsis(candidate) {
  var stringified = (0, _lang.toString)(candidate);
  var stringSlice = stringified.slice(0, STRING_MAX_LENGTH);
  var stringEllipsis = stringified.length > STRING_MAX_LENGTH ? '...' : '';
  return "".concat(stringSlice).concat(stringEllipsis);
};

exports.ellipsis = ellipsis;

var selectMessage = function selectMessage() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var isFalsy = !options.attr;
  var isUndefined = options.attr === undefined;
  var hasTypes = options.types.includes(_typeof(options.attr));

  if (isFalsy && options.isRequired) {
    return "[Sijang] Missing required API call RSAA \"".concat(options.name, "\" ") + "attribute while attempting to fetch " + "\"route:\n\"".concat(ellipsis(options.route), ".");
  }

  if (!isUndefined && !hasTypes) {
    return "[Sijang] Invalid API call RSAA \"".concat(options.name, "\" attribute while ") + "attempting to fetch route:\n\"".concat(ellipsis(options.route), "\". ") + "\nReceived \"".concat(ellipsis(options.attr), "\" ") + "of type ".concat(_typeof(options.attr), " instead of one of ") + "expected truthy types: [".concat(options.types.join(', '), "]");
  }
};
/**
 * Invariant triggers a message when value is empty or does not match type.
 * However, always return the value.
 *
 * @param  {Func} level
 * @param  {String} name
 * @param  {Any} type
 * @return {Any}
 */


var createInvariant = function createInvariant(level, name) {
  for (var _len = arguments.length, types = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    types[_key - 2] = arguments[_key];
  }

  return function invariant(attr, route) {
    var message = selectMessage({
      attr: attr,
      isRequired: level === console.error,
      name: name,
      route: route,
      types: types
    });
    message && level(message);
    return attr;
  };
};
/**
 * List of invariants for ACL the incoming RSAAs
 */


exports.createInvariant = createInvariant;
var invariant = {
  call: createInvariant(console.warn, 'call', 'string'),
  next: createInvariant(console.warn, 'next', 'function', 'object'),
  params: createInvariant(console.warn, 'params', 'object'),
  route: createInvariant(console.error, 'route', 'string'),
  schema: createInvariant(console.warn, 'schema', 'function')
  /**
   * Transform actions to Redux Standard API-call Action (RSAA).
   * Implies an strict contract. Include optional args fallbacks.
   *
   * @param {Object} args                         - Action signature
   *  @param {String} call                        - Unique redux action name reference
   *  @param {String} route                       - Unique path of the API route
   *  @param {Func|Func[]|Object} next            - What action should trigger when request is finished
   *    @param {Func|Func[]} next.CALL_API_SUCCESS  - If request success
   *    @param {Func|Func[]} next.CALL_API_FAIL     - If request fail
   *  @param {Any[]} [nextArgs=[]]                - List of arguments to be passed to next function
   *  @param {Object} [params]                    - Extends Fetch.prototype params
   *  @param {Func} [schema=identity]             - Pod's schema to ensure a format
   * @return {RSAA}
   */

};

var actionToRSAA = function actionToRSAA() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    call: invariant.call(args.call, args.route),
    next: invariant.next(args.next, args.route),
    nextArgs: (0, _util.defaultTo)(args.nextArgs, []),
    params: invariant.params((0, _util.defaultTo)(args.params, {}), args.route),
    route: invariant.route(args.route, args.route),
    schema: invariant.schema((0, _util.defaultTo)(args.schema, _util.identity), args.route)
  };
};

exports.actionToRSAA = actionToRSAA;